/**
 * @generated SignedSource<<dfd142025fb0aefdc7efe3c4d9e75e84>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productListSubscriptionQuery$variables = Record<PropertyKey, never>;
export type productListSubscriptionQuery$data = {
  readonly subscription: {
    readonly maxProducts: {
      readonly maxProducts: number | null;
      readonly numPublishedProducts: number | null;
    };
  } | null;
};
export type productListSubscriptionQuery = {
  response: productListSubscriptionQuery$data;
  variables: productListSubscriptionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "MaxProducts",
  "kind": "LinkedField",
  "name": "maxProducts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numPublishedProducts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxProducts",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "productListSubscriptionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "productListSubscriptionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3b1abf338c5ad2ef14c1d3bc652be35",
    "id": null,
    "metadata": {},
    "name": "productListSubscriptionQuery",
    "operationKind": "query",
    "text": "query productListSubscriptionQuery {\n  subscription {\n    maxProducts {\n      numPublishedProducts\n      maxProducts\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cce1cc44c5e3420c4fea2e0f3cab6d94";

export default node;
